<template>
  <div class="containerdiv">
    <div class="smallVideodiv">
      <video
        ref="myVideo"
        v-if="course.type==1"
        v-show="canPlay"
        class="video"
        id="myVideo"
        :poster="course.video.length>0&&course.video[videoIndex]?course.video[videoIndex].data.cover:''"
        :src="course.video.length>0&&course.video[videoIndex]?course.video[videoIndex].data.url:''"
        @error="videoErrorCallback"
        @timeupdate="handleVideoTimeUpdate"
        @play="handlePlay"
        play-btn-position="center"
        show-mute-btn
        page-gesture
        controls
        x5-video-player-type="h5-page"
      ></video>
      <van-image
        lazy-load
        v-show="!canPlay"
        v-if="course.type==1"
        class="videoTopImage"
        :src="course.video.length>0&&course.video[videoIndex]?course.picture[0]:course.picture[0]"
      ></van-image>
      <van-image
        lazy-load
        v-show="!canPlay"
        v-if="course.type==2"
        class="videoTopImage"
        :src="course.audio.length>0&&course.audio[videoIndex]?course.audio[videoIndex].data.cover:''"
      ></van-image>
      <van-image
        lazy-load
        v-show="!canPlay"
        v-if="course.type==3&&course.picture.length>0"
        class="videoTopImage"
        :src="course.picture.length>0?course.picture[videoIndex]:''"
      ></van-image>
      <div v-if="course.type==1" v-show="!canPlay" class="videoTop flex-center flex-column">
        <div
          class="videoTopTitle"
        >{{course.video.length>0&&course.video[videoIndex]?course.video[videoIndex].name:''}}</div>
        <div v-if="course.isBuy" style="margin-top:10px" class="videoTopBtn" @click="toPlay">立即播放</div>
        <div v-if="!course.isBuy" style="margin-top:10px" class="videoTopBtn" @click="toPlay">立即体验</div>
      </div>
    </div>
    <imt-audio
      @prevent="handlePrevent"
      :color="theme?theme.fontColor:''"
      :maxTryTime="course.isBuy?-1:course.tryTime"
      v-if="course.type==2"
      class="border-bottom"
      :src="course.audio.length>0&&course.audio[videoIndex]?course.audio[videoIndex].data.url:''"
      @prev="handlePrev"
      @next="handleNext"
    ></imt-audio>
    <!-- 团购横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="course.marketingCampaignType==1"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">¥</span>
          {{course.marketingCampaignPrice}}
          <span
            class="fs-12 border ml-1 pl-1 pr-1"
          >{{course.maxMemberCount}}人拼</span>
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">单价买</span>
          ¥{{course.price}}
          <!-- <span class="fs-12 m-price">¥{{course.nominalPrice}}</span> -->
        </div>
      </div>
      <div class="bg-white p-2 d-flex flex-column justify-content-around align-items-center">
        <div class="fs-14 themeFontColor">距拼购结束还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{time.d}}天</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.h>9?time.h:'0'+time.h}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.m>9?time.m:'0'+time.m}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.s>9?time.s:'0'+time.s}}</div>
        </div>
      </div>
    </div>
    <!-- 限时折扣横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="course.marketingCampaignType==2"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">¥</span>
          {{course.marketingCampaignPrice}}
          <span class="fs-12 border ml-1 pl-1 pr-1">限时折扣</span>
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">原价买</span>
          ¥{{course.price}}
          <!-- <span class="fs-12 m-price">¥{{course.nominalPrice}}</span> -->
        </div>
      </div>
      <div class="bg-white p-2 d-flex flex-column justify-content-around align-items-center">
        <div class="fs-14 themeFontColor">距折扣结束还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{time.d}}天</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.h>9?time.h:'0'+time.h}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.m>9?time.m:'0'+time.m}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.s>9?time.s:'0'+time.s}}</div>
        </div>
      </div>
    </div>

    <div class="headerdiv">
      <div class="headerdivTitle">{{course.name}}</div>
      <div v-if="course.type==1" class="headerdivText">{{course.salesVolume}}人购买 共{{course.video.length}}节 永久有效</div>
      <div v-if="course.type==2" class="headerdivText">{{course.salesVolume}}人购买 共{{course.audio.length}}节 永久有效</div>
      <div class="headerdivPrice">{{course.price}}</div>
      <div v-if="!course.isBuy">{{'您未购买该资源，只能体验' + course.tryTime + '秒钟'}}</div>
    </div>
    <!-- 团购 -->
    <div class="c-list mt-2" v-if="course.marketingCampaignType==1">
      <div class="c-row flex-column align-items-start">
        <div class="fs-14 title">已经有{{course.memberCount}}人参与活动</div>
        <div
          v-for="(item,index) in course.groupBuy"
          :key="index"
          class="position-relative pt-1 pb-1 w-100 d-flex flex-row justify-content-between align-items-center"
        >
          <div
            :style="{width: (20+((item.groupBuyList.length<=2?item.groupBuyList.length:2))*20)+'px',height:'40px'}"
          >
            <div
              class="position-absolute d-flex flex-row align-items-center rounded-circle"
              :style="{height:'40px',width:'40px',left: cIndex*20+'px',border:'2px white solid'}"
              v-for="(cItem,cIndex) in item.groupBuyList"
              :key="cIndex"
              v-if="cIndex<=3"
            >
              <van-image lazy-load round width="36" height="36" :src="cItem.memberAvatar" />
            </div>
          </div>
          <div class="ml-3 flex-1">
            <div>
              <span>还差</span>
              <span class="themeFontColor">{{course.maxMemberCount-item.groupBuyList.length}}人</span>
              <span>参团</span>
            </div>
            <div v-if="groupEndTimes['item_'+item.groupBuyGroupId].time">
              <span>剩余</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.d+'天'}}</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.h>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.h:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.h}}</span>
              <span>:</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.m>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.m:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.m}}</span>
              <span>:</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.s>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.s:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.s}}</span>
            </div>
          </div>
          <div
            class="pl-2 pr-2 pt-1 pb-1 themeBGColor text-white"
            :style="{borderRadius: '50px'}"
            @click="handleCommit(course.marketingCampaignType,item.groupBuyGroupId)"
          >去参团</div>
        </div>
      </div>
    </div>

    <div v-if="course.type==2||course.type==1" class="tab d-flex flex-row justify-content-around">
      <div
        class="flex-1 flex-center title"
        :class="{select:tabIndex==0}"
        @click="changeTabIndex(0)"
      >详情</div>
      <div
        class="flex-1 flex-center title"
        :class="{select:tabIndex==1}"
        @click="changeTabIndex(1)"
      >目录</div>
      <!-- <div class="tabItem flex-1 flex-center" :class="{select:tabIndex==2}" @click="changeTabIndex(2)">相关课程</div> -->
    </div>
    <div class="headerdiv" v-show="tabIndex==0">
      <div class="title mt">讲师介绍</div>
      <div class="mt d-flex flex-row justify-content-start align-items-center">
        <van-image
          lazy-load
          class="teacherAvater"
          width="60"
          height="60"
          round
          :src="course.teacher?course.teacher.avatar:''"
        ></van-image>
        <div>
          <div class="title">{{course.teacher?course.teacher.teacherName:''}}</div>
          <div class="headerdivText">{{course.teacher?course.teacher.identity:''}}</div>
        </div>
      </div>
      <div class="title mt">课程详情</div>
      <div class="desc mt">{{course.intro}}</div>
      <div class="htmlContent" v-html="course.detail"></div>
    </div>
    <div v-show="tabIndex==1&&course.type==1">
      <div
        class="bg-white pl-2 pr-2 pt-1 pb-1 border-bottom"
        v-for="(item,index) in course.video"
        :key="index"
        @click="handleSwitchVideo(item,index)"
      >
        <div class="title" :class="{selectText:videoIndex==index}">{{item.name}}</div>
        <div class="headerdivText" :class="{selectText:videoIndex==index}">{{item.description}}</div>
      </div>
    </div>
    <div v-show="tabIndex==1&&course.type==2">
      <div
        class="bg-white pl-2 pr-2 pt-1 pb-1 border-bottom"
        v-for="(item,index) in course.audio"
        :key="index"
        @click="handleSwitchVideo(item,index)"
      >
        <div class="title" :class="{selectText:videoIndex==index}">{{item.name}}</div>
        <div class="headerdivText" :class="{selectText:videoIndex==index}">{{item.description}}</div>
      </div>
    </div>
    <div v-if="!course.isBuy" class="page-bottom">
      <router-link to="/" class="p-b-btn">
        <span class="yticon icon-xiatubiao--copy"></span>
        <span>首页</span>
      </router-link>
      <div class="action-btn-group flex-center">
        <div

          class="action-btn no-border buy-now-btn"
          @click="toPreCourse()"
        >立即购买</div>
<!--        <div-->
<!--          v-if="course.marketingCampaignType==1"-->
<!--          class="d-flex flex-row w-75 van-row&#45;&#45;justify-space-around"-->
<!--        >-->
<!--          <div class="action-btn no-border buy-now-btn" @click="handleCommit()">-->
<!--            <div class="fs-12" :style="{height:'14px'}">¥{{course.price}}</div>-->
<!--            <div>单独购买</div>-->
<!--          </div>-->
<!--          <div-->
<!--            class="action-btn no-border add-cart-btn"-->
<!--            @click="handleCommit(course.marketingCampaignType)"-->
<!--          >-->
<!--            <div class="fs-12" :style="{height:'14px'}">¥{{course.groupLeaderPrice}}</div>-->
<!--            <div>我要开团</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          v-if="course.marketingCampaignType == 2"-->
<!--          class="action-btn no-border buy-now-btn"-->
<!--          @click="handleCommit(course.marketingCampaignType)"-->
<!--        >立即购买</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import imtAudio from "@/components/imt-audio/imt-audio.vue"
import {
  mapState
} from 'vuex';
export default {
  components: {
    imtAudio
  },
  computed: {
    ...mapState(['hasLogin', 'userInfo']),
    theme: function () {
      return this.$store.getters.config.theme
    },
  },
  data () {
    return {
      canPlay: false,
      videoIndex: 0,
      tabIndex: 0,
      id: 0,
      course: {},
      time: {
        d: 0,
        h: 0,
        m: 0,
        s: 0
      },
      groupEndTimes: {},
      groupId: null
    }
  },
  mounted () {
    let query = this.$route.query
    this.id = query.id
    console.log('getCourseInfo')
    this.getCourseInfo()
  },
  destroyed () {
    clearInterval(this.timeIn)
  },
  methods: {
    share (title, desc, img) {
      let that = this
      that.$http.getJsSdkConfig().then(res => {
        that.updateShare(title, desc, img)
      })
    },
    updateShare (title, desc, img) {
      desc = desc ? desc : localStorage.getItem('desc')
      img = img ? img : localStorage.getItem('logo')
      let href = location.href
      let userId = localStorage.getItem('userId')
      if (userId) {
        if (href.indexOf('?') > -1) {
          href += '&userId=' + userId
        } else {
          href += '?userId=' + userId
        }
      }
      let share = {
        title: title, // 分享标题
        desc: desc || href, // 分享描述
        link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: img, // 分享图标
      }
      ///朋友和QQ
      window.wx.updateAppMessageShareData({
        ...share
      })
      ///朋友圈和空间
      window.wx.updateTimelineShareData({
        ...share
      })
      ///微博
      window.wx.onMenuShareWeibo({
        ...share
      });
    },
    setTitle (title) {
      document.title = title
    },
    changeTabIndex (index) {
      this.tabIndex = index
    },
    fomartHtmlImg () {
      let htmlContent = document.getElementsByClassName('htmlContent')[0]
      let imgs = htmlContent.getElementsByTagName('img')
      let screenWidth = document.body.clientWidth;
      imgs.forEach(element => {
        let width = element.getAttribute('width')
        if (width && width * 1 > screenWidth) {
          element.removeAttribute('width')
          element.removeAttribute('height')
        }
      });
    },
    getCourseInfo () {
      this.$http.request(this.$http.pathMap.courseInfo + this.id).then(res => {
        this.course = {...res.data,tryTime:10}
        this.setTitle(this.course.name)
        let that = this
        that.$nextTick(() => {
          that.share(that.course.name, that.course.intro, that.course.picture && that.course.picture.length > 0 ? that.course.picture[0] : "")
          that.fomartHtmlImg()
        })

        if (this.course.marketingCampaignType == 1) {
          this.startInterval1()
        }
        if (this.course.marketingCampaignType == 2) {
          this.startInterval2()
        }
        this.$nextTick(() => {
          this.videoContext = this.$refs.myVideo
        })
      })
    },
    videoErrorCallback (e) {
      console.log(e)
    },
    toPlay () {
      this.canPlay = true
      this.videoContext.play()
    },
    handleSwitchVideo (item, index) {
      this.videoIndex = index
      if (this.canPlay) {
        setTimeout(() => {
          this.videoContext.play()
        }, 1000)
      }
    },
    handlePrev () {
      if (this.videoIndex == 0) {
        this.$toast('没有上一首了')
      } else {
        this.videoIndex -= 1
      }
    },
    handleNext () {
      if (this.videoIndex >= this.course.courseCatalogs.length - 1) {
        this.$toast('没有下一首了')
      } else {
        this.videoIndex += 1
      }
    },

    handleCommit (type, groupId) {
      this.type = type;
      this.groupId = groupId;
      if (groupId) {
        for (let item of this.course.groupBuy) {
          if (item.groupBuyGroupId == groupId) {
            for (let u of item.groupBuyList) {
              if (u.memberId == this.userInfo.id) {
                this.$toast('您已经参加该团，不能重复参加')
                return;
              }
            }
          }
        }
      }
      this.commit(type, groupId)
    },
    commit (marketingCampaignType, groupBuyGroupId) {
      let id = this.course.id;
      if (this.hasLogin) {
        let query = { id }
        if (marketingCampaignType) {
          query.marketingCampaignType = marketingCampaignType
        }
        if (groupBuyGroupId) {
          query.groupBuyGroupId = groupBuyGroupId
          for (let item of this.course.groupBuy) {
            if (item.groupBuyGroupId == groupBuyGroupId) {
              for (let u of item.groupBuyList) {
                if (u.memberId == this.userInfo.id) {
                  this.$toast('您已经参加该团，不能重复参加')
                  return;
                }
              }
            }
          }
        }
        this.$router.push({
          path: '/onlinePages/course/preCourse',
          query
        })
      } else {
        this.$router.push('/pages/public/login')
      }
    },

    toPreCourse () {
      let id = this.course.id;
      this.$router.push({
        path: '/onlinePages/course/preCourse',
        query: {
          id
        }
      })
    },
    handleVideoTimeUpdate () {
      let { currentTime } = this.videoContext
      if (!this.course.isBuy && currentTime >= this.course.tryTime) {
        this.videoContext.pause()
        if (currentTime > this.course.tryTime) {
          this.videoContext.currentTime = this.course.tryTime
        }
        this.handlePrevent(this.course.tryTime)
      }
    },
    handlePlay () {
      let { currentTime } = this.videoContext
      if (!this.course.isBuy && currentTime >= this.course.tryTime) {
        this.videoContext.pause()
        if (currentTime > this.course.tryTime) {
          this.videoContext.currentTime = this.course.tryTime
        }
        this.handlePrevent(this.course.tryTime)
      }
    },
    handlePrevent (tryTime) {
      this.$toast('您未购买该资源，只能体验' + tryTime + '秒钟')
    },
    startInterval1 () {
      //总倒计时
      this.serverTime = new Date(this.course.serverTime.replace(/-/g, "/")).getTime()
      this.groupEndTime = new Date(this.course.marketingCampaignEndTime.replace(/-/g, "/")).getTime()
      this.groupEndTimes = {}
      for (let item of this.course.groupBuy) {
        let endTime = new Date(item.dueTime.replace(/-/g, "/")).getTime()
        this.groupEndTimes['item_' + item.groupBuyGroupId] = { endTime, time: { d: 0, h: 0, m: 0, s: 0 } }
      }
      let that = this
      that.timeIn = setInterval(() => {
        that.serverTime += 500
        let time = that.computeTime(this.serverTime, this.groupEndTime)
        if (time) {
          this.time = time
        } else {
          // this.getProduct()
        }
        for (let key in that.groupEndTimes) {
          let endTime = that.groupEndTimes[key].endTime
          let time = that.computeTime(that.serverTime, endTime)
          if (time) {
            that.groupEndTimes[key].time = time
          } else {
            // this.getProduct()
          }
        }
      }, 500)
    },
    startInterval2 () {
      //总倒计时
      this.serverTime = new Date(this.course.serverTime.replace(/-/g, "/")).getTime()
      this.groupEndTime = new Date(this.course.marketingCampaignEndTime.replace(/-/g, "/")).getTime()
      let that = this
      that.timeIn = setInterval(() => {
        that.serverTime += 500
        let time = that.computeTime(this.serverTime, this.groupEndTime)
        if (time) {
          this.time = time
        } else {
          // this.getProduct()
        }
      }, 500)
    },
    computeTime (startTime, endTime) {
      if (startTime >= endTime) {
        return false
      }
      let SS = Math.floor(endTime - startTime) / 1000
      let d = parseInt(SS / (3600 * 24))
      let h = parseInt((SS - (d * 3600 * 24)) / 3600)
      let m = parseInt((SS - (d * 3600 * 24) - (h * 3600)) / 60)
      let s = parseInt((SS - (d * 3600 * 24) - (h * 3600) - (m * 60)))
      return {
        d, h, m, s
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.containerdiv {
  padding-bottom: 67px;
}
.smallVideodiv {
  position: relative;
  width: 100%;
  height: 230px;
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.videoTop {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
}

.videoTopImage {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.videoTopTitle {
  font-size: $uni-font-size-lg;
  color: white;
}

.videoTopBtn {
  background-color: #333333;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  color: white;
}

.headerdiv {
  padding: 10px;
  background-color: white;
}

.headerdivTitle {
  font-size: $uni-font-size-lg;
  color: $uni-text-color;
  line-height: 1;
}

.headerdivText {
  margin-top: 10px;
  font-size: $uni-font-size-sm;
  color: $uni-text-color-grey;
  line-height: 1;
}

.headerdivPrice {
  margin-top: 10px;
  font-size: $uni-font-size-lg + 2px;
  color: var(--theme-font-color);
  line-height: 1;

  &:before {
    content: "￥";
    font-size: 13px;
  }
}

.tab {
  height: 40px;
  border-bottom: 1px $uni-border-color-base solid;
  border-top: 1px $uni-border-color-base solid;
  background-color: white;
}

.teacherAvater {
  margin-right: 10px;
}

.title {
  font-size: $uni-font-size-lg;
  color: $uni-text-color;
}

.desc {
  font-size: $uni-font-size-base;
  color: $uni-text-color;
}

.select {
  color: var(--theme-font-color);
  border-bottom: 3px var(--theme-font-color) solid;
}

.selectText {
  color: var(--theme-font-color);
}

.mt {
  margin-top: 10px;
}
/* 底部操作菜单 */
.page-bottom {
  position: fixed;
  left: 15px;
  bottom: 15px;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 30px);
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;

  .p-b-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $uni-font-size-sm;
    color: $font-color-base;
    width: 48px;
    height: 40px;

    .yticon {
      font-size: 20px;
      line-height: 24px;
      color: $font-color-light;
    }

    &.active,
    &.active .yticon {
      color: var(--theme-font-color);
    }

    .icon-fenxiang2 {
      font-size: 21px;
      transform: translateY(-2upx);
    }

    .icon-shoucang {
      font-size: 23px;
    }
  }

  .action-btn-group {
    display: flex;
    flex: 1;
    height: 38px;
    border-radius: 100px;
    overflow: hidden;
    box-shadow: 0 10px 20px -8px #fa436a;
    box-shadow: 1px 2px 5px rgba(219, 63, 96, 0.4);
    background: var(--theme-font-color);
    margin-left: 10px;
    margin-right: 10px;
    position: relative;

    .action-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 90px;
      height: 100%;
      font-size: $uni-font-size-base;
      color: white;
      padding: 0;
      border-radius: 0;
      background: transparent;
    }
    .action-btn::after {
      border: none;
    }
  }
}
.c-list {
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-base;
  background: #fff;

  .c-row {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    position: relative;
  }

  .tit {
    min-width: 70px;
    max-width: 100px;
    text-align: left;
  }

  .con {
    flex: 1;
    text-align: left;
    color: $font-color-dark;

    .selected-span {
      margin-right: 5px;
    }
  }

  .bz-list {
    height: 20px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-dark;

    span {
      display: inline-block;
      margin-right: 15px;
    }
  }

  .con-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: $font-color-dark;
    line-height: 20px;
  }

  .red {
    color: var(--theme-font-color);
  }
}
</style>
